import type { EnvironmentStand } from './environment-stands'

// Эндпоинты CMO для каждого стенда проекта
export const CMO_ENDPOINTS: Record<EnvironmentStand, string> = {
  dev: 'https://dev-rp.rshb.ru:443/api/dbofl/personalizations',
  test: 'https://dev-rp.rshb.ru:8443/api/dbofl/personalizations',
  preprod: 'https://dev-rp.rshb.ru:8443/api/dbofl/personalizations',
  prod: 'https://rp.rusagrobank.com:8443/api/dbofl/personalizations',
}

// Стенды CMO для каждого стенда проекта
export const CMO_STANDS: Record<EnvironmentStand, string> = {
  dev: 'dev-stand',
  test: 'test-stand',
  preprod: 'preprod-stand',
  prod: 'prod-stand',
}

// Путь к основному скрипту CMO
export const CMO_SCRIPT_URL = '/shared/cmo-digital-personalization.js'
